export let Spec = /*#__PURE__*/function (Spec) {
  Spec["AppControllerLayoutFix"] = "specs.siteSearch.AppControllerLayoutFix";
  Spec["NewResultsPerPageDefaultValue"] = "specs.siteSearch.NewResultsPerPageDefaultValue";
  Spec["ProGallery"] = "specs.siteSearch.ProGallery";
  Spec["UseWarmupData"] = "specs.siteSearch.UseWarmupData";
  Spec["MobileSettings"] = "specs.siteSearch.MobileSettings";
  Spec["RemoveCorruptedSiteSearch"] = "specs.siteSearch.RemoveCorruptedSiteSearch";
  Spec["ResponsiveSkin"] = "specs.siteSearch.ResponsiveSearchBoxSkin";
  Spec["ShowMoreCollections"] = "specs.siteSearch.showMoreCollections";
  Spec["useSearchHttpClient"] = "specs.siteSearch.useSearchHttpClient";
  Spec["VespaSiteSearchEndpoints"] = "specs.siteSearch.VespaSiteSearchEndpoints";
  Spec["SearchResultsPageProductsSlot"] = "specs.siteSearch.SearchResultsPageProductsSlot";
  Spec["ProductResultFromStoreFront"] = "specs.siteSearch.ProductResultFromStoreFront";
  return Spec;
}({});
//# sourceMappingURL=specs.js.map